import React, { useState } from 'react'

function KhasSearchInput({ value, onChange, placeholder = 'Cari...', style = {} }) {
  const [focused, setFocused] = useState(false)
  return (
    <div style={{ position:'relative', display:'flex', alignItems:'center', width:'100%', ...style }}>
      <svg aria-hidden="true" viewBox="0 0 24 24"
        style={{ position:'absolute', left:14, width:16, height:16, fill:'#9e9ea7', pointerEvents:'none', flexShrink:0 }}>
        <path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"/>
      </svg>
      <input
        type="search" value={value} onChange={onChange} placeholder={placeholder}
        onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
        style={{
          width:'100%', height:40, lineHeight:'28px',
          padding:'0 1rem 0 2.5rem',
          // ← border selalu visible, bukan transparent
          border: focused ? '2px solid rgba(0,77,39,0.55)' : '2px solid #cbd5e1',
          borderRadius:8, outline:'none',
          background: focused ? '#fff' : '#f8fafc',
          color:'#0d0c22', fontFamily:"'Poppins', sans-serif", fontSize:14,
          // ← shadow selalu ada, lebih kuat saat fokus
          boxShadow: focused
            ? '0 0 0 4px rgba(0,77,39,0.08), 0 1px 4px rgba(0,0,0,0.08)'
            : '0 1px 3px rgba(0,0,0,0.10)',
          transition:'all .25s ease',
        }}
      />
    </div>
  )
}

export default KhasSearchInput